/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, {Component} from 'react';
import urlHelper from "../../../_helpers/url.format.helper";
import config from "../../../config";
import {TEXT_TYPES} from "../../../constants/APP_CONSTANTS";
import AxiosClient from "../../../_helpers/http.helper";
import ActionCard from "../../widgets/ActionCard/ActionCard";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingIndicator from "../../widgets/LoadingIndicator/LoadingIndicator";
import ReactTable from "react-table";
import moment from "moment";
import intersectionBy from "lodash/intersectionBy";

export default class CCDeletionStatus extends Component {

    constructor(props) {
        super(props);
        this.state = {
            curatedCollectionBatches: [],
            pageSize: 25,
            pageNumber: null,
            totalItems: 0,
            hasMore: true,
            selectedBatchId: null,
            statusesList: {},
            activeActionCards: [],
            isLoading: true
        };
    }

    componentDidMount() {
        this.loadMore();
    }

    loadMore = () => {
        if (!this.state.hasMore) {
            return;
        }

        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.getCuratedCollectionBatches,
            {
                fileMode: "Delete",
                pageSize: this.state.pageSize,
                pageNumber:
                    this.state.pageNumber === null
                        ? 0
                        : this.state.pageNumber + 1
            }
        );
        AxiosClient.get(url).then(response => {
            const results = response.data;

            this.setState(prevState => ({
                curatedCollectionBatches: intersectionBy([
                    ...prevState.curatedCollectionBatches,
                    ...results.content
                ], 'batchId'),
                pageNumber: results.number,
                totalItems: results.totalElements,
                hasMore: !results.last,
                isLoading: false
            }));
        });
    };

    toggleActionCard = index => {
        this.setState(prevState => {
            const prevActive = prevState.activeActionCards;
            return {
                activeActionCards: prevActive.includes(index)
                    ? prevActive.filter(active => active !== index)
                    : prevActive.concat([index])
            };
        });
    };

    generateStatusesList = selectedBatchId => {
        const selectedBatch = this.state.curatedCollectionBatches.find(
            item => item.batchId === selectedBatchId
        );

        const statusesList = {
            "FAILED": [],
            "PENDING": [],
            "COMPLETED": [],

        };
        selectedBatch.preCuratedCollectionStatus
            .map(item => {
                if (item.createStatus === "PROCESSING") {
                    item.createStatus = "PENDING";
                }
                return item;
            })
            .forEach(statusItem => {
                statusesList[statusItem.createStatus]
                    ? statusesList[statusItem.createStatus].push(statusItem)
                    : (statusesList[statusItem.createStatus] = [statusItem]);
            });

        this.setState({
            statusesList,
            selectedBatchId,
            activeActionCards: Object.keys(statusesList).map(
                (_, index) => index
            )
        });
    };

    renderActionCards = () => (
        <div>
            {Object.entries(this.state.statusesList).map(
                ([statusName, statusItems], index) => ((statusItems.length !== 0)
                    && <ActionCard
                        className={`action-card-${statusName}`}
                        key={index}
                        headerOnClick={() => this.toggleActionCard(index)}
                        controlsLeft={
                            <div className={`pe-label pe-bold card-title`}>
                                {statusName}
                            </div>
                        }
                        controlsRight={
                            <span className={`badge px-2`}>
                                {statusItems.length}
                            </span>
                        }
                    >
                        {this.state.activeActionCards.includes(index) && (
                            <div>
                                <table className="pe-table mb-0">
                                    <thead>
                                        <tr>
                                            {statusName !== "FAILED" && (
                                                <th scope="col">
                                                    Collection ID
                                                </th>
                                            )}
                                            <th scope="col">Title</th>
                                            <th scope="col">ISBN</th>
                                            {statusName === "FAILED" && (
                                                <th scope="col">Comment</th>
                                            )}
                                            <th scope="col">Status ID</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {statusItems.map((item, id) => (
                                            <tr key={id}>
                                                {statusName !== "FAILED" && (
                                                    <th scope="row">
                                                        {item.collectionId}
                                                    </th>
                                                )}
                                                <td>{item.title}</td>
                                                <td>{item.isbn}</td>
                                                {statusName === "FAILED" && (
                                                    <td>{item.comment}</td>
                                                )}
                                                <td>{item.id}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </ActionCard>
                )
            )}
        </div>
    );

    render() {
        const columns = [
            {
                Header: "Batch ID",
                accessor: "batchId",
                sortable: true,
            },
            {
                Header: "Filename",
                accessor: "filename",
                sortable: true,
            },
            {
                Header: "Upload Date",
                id: "creationDate",
                width: 150,
                accessor: d =>
                    moment(d.creationDate)
                        .utc()
                        .format("MM/DD/YY HH:mm z"),
                sortable: true
            }
        ];

        return (
            <div className="content-home-page cc-deletion-status">
                <div>
                    <label className="pe-page-title--small">
                        {TEXT_TYPES.CC_DELETION_STATUS}
                    </label>
                    <hr/>
                </div> {this.state.isLoading && <LoadingIndicator/>}
                <div className="pe-row">
                    <div className="pe-col-4 pt-4">
                        {this.state.totalItems > 0 && (
                            <div id="scrollTable" className="infiniteScroll">
                                <InfiniteScroll
                                    dataLength={
                                        this.state.curatedCollectionBatches
                                            .length
                                    }
                                    next={this.loadMore}
                                    hasMore={this.state.hasMore}
                                    loader={<LoadingIndicator/>}
                                    scrollableTarget="scrollTable"
                                >
                                    <div className="table-wrap">
                                        <ReactTable
                                            className="-highlight -striped"
                                            data={
                                                this.state
                                                    .curatedCollectionBatches
                                            }
                                            showPagination={false}
                                            columns={columns}
                                            defaultPageSize={
                                                this.state.totalItems
                                            }
                                            minRows={0}
                                            sortable={false}
                                            pageText=""
                                            noDataText="No Curated Collection Batches found"
                                            getTrProps={(_, rowInfo) => {
                                                const selectedBatch = rowInfo.original.batchId;
                                                return {
                                                    style: {
                                                        backgroundColor: selectedBatch === this.state.selectedBatchId ? "#ccc" : "inherit",
                                                        cursor: "pointer"
                                                    },
                                                    onClick: () => this.generateStatusesList(selectedBatch)
                                                };
                                            }}
                                        />
                                    </div>
                                </InfiniteScroll>
                            </div>
                        )}
                    </div>
                    <div className="pe-col-8">{this.renderActionCards()}</div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/CCManagement/CCDeletionStatus.js